const passion1 = {
  color: [
    // "#fc97af",
    // "#87f7cf",
    // "#f7f494",
    // "#72ccff",
    // "#f7c5a0",
    // "#d4a4eb",
    // "#d2f5a6",
    // "#76f2f2"
    "#1EA7D7",
    "#8E6161",
    "#839550",
    "#4A4A8C",
  ],
  backgroundColor: "rgba(110, 110, 110)",
  textStyle: {},
  title: {
    textStyle: {
      color: "#ffffff",
    },
    subtextStyle: {
      color: "#dddddd",
    },
  },

  radar: {
    itemStyle: {
      borderWidth: "4",
    },
    lineStyle: {
      width: "3",
    },
    symbolSize: "0",
    symbol: "circle",
    smooth: true,
  },
  bar: {
    itemStyle: {
      barBorderWidth: 0,
      barBorderColor: "#ccc",
    },
  },
  pie: {
    itemStyle: {
      borderWidth: 0,
      borderColor: "#ccc",
    },
  },
  scatter: {
    itemStyle: {
      borderWidth: 0,
      borderColor: "#ccc",
    },
  },
  boxplot: {
    itemStyle: {
      borderWidth: 0,
      borderColor: "#ccc",
    },
  },
  parallel: {
    itemStyle: {
      borderWidth: 0,
      borderColor: "#ccc",
    },
  },
  sankey: {
    itemStyle: {
      borderWidth: 0,
      borderColor: "#ccc",
    },
  },
  funnel: {
    itemStyle: {
      borderWidth: 0,
      borderColor: "#ccc",
    },
  },
  gauge: {
    itemStyle: {
      borderWidth: 0,
      borderColor: "#ccc",
    },
  },

  geo: {
    itemStyle: {
      areaColor: "#f3f3f3",
      borderColor: "#999999",
      borderWidth: 0.5,
    },
    label: {
      color: "#893448",
    },
    emphasis: {
      itemStyle: {
        areaColor: "rgba(255,178,72,1)",
        borderColor: "#eb8146",
        borderWidth: 1,
      },
      label: {
        color: "rgb(137,52,72)",
      },
    },
  },
  categoryAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: "#fff",
        // x轴线颜色
      },
    },
    axisTick: {
      show: false,
      lineStyle: {
        color: "#333",
      },
    },
    axisLabel: {
      show: true,
      color: "#fff",
    },
    splitLine: {
      show: false,
      lineStyle: {
        color: ["#e6e6e6"],
      },
    },
    splitArea: {
      show: false,
      areaStyle: {
        color: ["rgba(250,250,250,0.05)", "rgba(200,200,200,0.02)"],
      },
    },
  },
  valueAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: "#fff",
        // 调整Y轴线颜色
      },
    },
    axisTick: {
      show: false,
      lineStyle: {
        color: "#333",
      },
    },
    axisLabel: {
      show: true,
      color: "#fff",
    },
    splitLine: {
      show: false,
      lineStyle: {
        color: ["#e6e6e6"],
      },
    },
    splitArea: {
      show: false,
      areaStyle: {
        color: ["rgba(250,250,250,0.05)", "rgba(200,200,200,0.02)"],
      },
    },
  },

  timeAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: "#fff",
      },
    },
    axisTick: {
      show: false,
      lineStyle: {
        color: "#333",
      },
    },
    axisLabel: {
      show: true,
      color: "#aaaaaa",
    },
    splitLine: {
      show: false,
      lineStyle: {
        color: ["#e6e6e6"],
      },
    },
    splitArea: {
      show: false,
      areaStyle: {
        color: ["rgba(250,250,250,0.05)", "rgba(200,200,200,0.02)"],
      },
    },
  },
  toolbox: {
    iconStyle: {
      borderColor: "#999999",
    },
    emphasis: {
      iconStyle: {
        borderColor: "#666666",
      },
    },
  },
  legend: {
    textStyle: {
      color: "#fff",
    },
  },
};

export default passion1;
